import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { PuntoInspeccionViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-porcentajesemanal-list-edit',
    templateUrl: './porcentajesemanal-list-edit.component.html',
    styleUrls: ['./porcentajesemanal-list-edit.component.scss'],
})
export class PorcentajeSemanalListEditComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: any[] = [];
    @Input() saving: boolean;
    @Output() porcentajeTotalValido = new EventEmitter<boolean>();
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    titleList = 'Porcentajes Semanales de Distribución';

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
        if (this.turboTable) {
            this.turboTable.first = 0;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            /*    this.result = Array.isArray(changes.result.currentValue) ? [...changes.result.currentValue] : [];*/
            this.loading = false;
        }
    }

    private initCols(): void {
        const model = proxiedPropertiesOf<PuntoInspeccionViewModel>();

        this.cols = [
            { field: model.Id, header: 'Id', display: 'none' },
            { field: model.Descripcion, header: 'Descripción' },
            { field: model.PorcentajeSemanal, header: 'Porcentaje Semanal' },
            /*            { field: model.NumeroInspectores, header: 'Número Inspectores' },*/ //TODO: agoldero comentado hasta que lo soliciten
            { field: model.FinesDeSemana, header: 'Fines de Semana' },
        ];
    }

    // Método para calcular el total
    getPorcentajeTotal(): number {
        if (!this.result) return 0;
        return this.result.reduce((sum, item) => sum + (Number(item.PorcentajeSemanal) || 0), 0);
    }

    isPorcentajeTotalValido(): boolean {
        const total = this.getPorcentajeTotal();
        // Tolerancia de 2 decimales por posibles errores de coma flotante
        return Math.abs(total - 100) < 0.01;
    }

    formatPorcentaje(rowData: any, field: string) {
        if (rowData[field] !== null && rowData[field] !== undefined) {
            // Redondea a 2 decimales
            rowData[field] = parseFloat(rowData[field]).toFixed(2);
            // Convierte a número si lo necesitas como number
            rowData[field] = +rowData[field];
        }
    }

    onAnyFieldChanged() {
        this.porcentajeTotalValido.emit(this.isPorcentajeTotalValido());
    }

    handleFinesDeSemanaChange(event: any, rowIndex: number) {
        this.result[rowIndex].FinesDeSemana = event.checked;
        this.onAnyFieldChanged();
    }
}
